import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConQas: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConQaMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConQasRequest({dispatch}) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConQas", null);
            } else {
                dispatch("receivingWebConQas"); // สถานะ กำลังบันทึก

                axios.get('/webConQas').then(res => {

                    dispatch("receiveWebConQas", res.data);
                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receiveWebConQas", null);
                    })
            }
        },
        loadWebConQaRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConQa", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConQa");
                axios.get('/webConQas/' + id).then(res => {
                    dispatch("receiveWebConQa", res.data);
                })
            }
        },
        updateWebConQaRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConQa");
            axios.put('/webConQas/' + payload.qa_id, payload).then(res => {
                dispatch("updateWebConQa", res.data);
            })
        },
        createWebConQaRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConQa");
            axios.post('/webConQas', payload).then(res => {
                dispatch("receiveWebConQa", res.data);
            })
        },
        deleteWebConQaRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConQa", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConQa", payload);

            axios.post('/delete_webConQas', payload).then(res => {
                dispatch("deleteWebConQa", {qa_id: payload.qa_id, res: res});
            })


        },
        receiveWebConQas({commit}, payload) {
            commit("RECEIVED_QAS", payload)
        },
        receivingWebConQas({commit}) {
            commit("RECEIVING_QAS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConQa({commit}, payload) {
            commit("RECEIVED_QA", payload)
        },
        receivingWebConQa({commit}) {
            commit("RECEIVING_QAS") //call matutions --> state.isReceiving = true;
        },
        updateWebConQa({commit}, payload) {
            commit("UPDATED_QA", payload)
        },
        updatingWebConQa({commit}) {
            commit("UPDATING_QA") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConQa({commit}, payload) {
            commit("DELETED_QA", payload)
        },
        deletingWebConQa({commit}, payload) {
            commit("DELETING_QA", payload)
        },
        afterDeleteWebConQa({commit}, payload) {
            commit("AFFTER_DELETED_QA", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_QAS(state, payload) {
            state.webConQas = payload;
            state.isReceiving = false;

        },
        RECEIVING_QAS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_QA(state, payload) {


            if (payload.qa_id == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let webConQaMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConQaMessage: (state.webConQaMessage == webConQaMessage ? webConQaMessage + ' ' : webConQaMessage),

                });
            } else {
                let webConQaMessage = 'บันทึกสำเร็จ! รายการ ' + payload.qa_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConQas: [...state.webConQas, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConQaMessage: (state.webConQaMessage == webConQaMessage ? webConQaMessage + ' ' : webConQaMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_PREFIX(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_QA(state, payload) {
            let index = state.webConQas.findIndex(p => p.qa_id === payload.qa_id);
            let webConQaMessage = 'บันทึกสำเร็จ! รายการ ' + payload.qa_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConQas: state.webConQas.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConQaMessage: (state.webConQaMessage == webConQaMessage ? webConQaMessage + ' ' : webConQaMessage),
            })
        },
        UPDATING_QA(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_QA(state, payload) {


            if (payload.qa_id == undefined || payload.res.data.message == 'Relation') {
                let webConQaMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.qa_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConQaMessage: (state.webConQaMessage == webConQaMessage ? webConQaMessage + ' ' : webConQaMessage),

                });
            } else {
                let indexToDelete = state.webConQas.findIndex(p => p.qa_id === payload.qa_id);
                let webConQas = [...state.webConQas];
                webConQas.splice(indexToDelete, 1);
                let webConQaMessage = 'บันทึกสำเร็จ! รายการ ' + payload.qa_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConQas: [...webConQas],
                    isDeleting: false,
                    idToDelete: null,
                    webConQaMessage: (state.webConQaMessage == webConQaMessage ? webConQaMessage + ' ' : webConQaMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_QA(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.qa_id;
        },
        AFFTER_DELETED_QA(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
